<script setup lang='ts'>
import type { SeriesDetailLabel } from '~/logic/reputation/detail'

const props = withDefaults(defineProps<{
  seriesCoverImg?: string
  seriesDisplacements?: string
  seriesGearboxs?: string
  seriesBodys?: string
  statComplainTotal?: number
  statFinishRate?: number
  statQt?: number
  statCacsi?: number
  brandId?: number
  seriesId?: number
  seriesName?: string
  labels: SeriesDetailLabel
}>(), {
  seriesCoverImg: '',
  seriesName: '',
  seriesDisplacements: '',
  seriesGearboxs: '',
  seriesBodys: '',
  statComplainTotal: 0,
  statFinishRate: 0,
  statQt: 0,
  statCacsi: 0,
})
</script>

<template>
  <div class="p-6">
    <div class="w-70 relative rounded-1.5 overflow-hidden mb-2 bg-slate-2">
      <div class="font-bold text-8 flex items-center text-center justify-center  break-all grid place-content-center h-35">
        {{ props.seriesName }}
      </div>
      <NuxtLink
        :to="`/publish?brandId=${brandId}&seriesId=${seriesId}`"
        class="text-3.5 bg-orange-6  text-center py-2 text-6 text-white block"
      >
        我要投诉
      </NuxtLink>
    </div>
    <div class="label-item flex items-start">
      <span class="w-17.5">排量:</span>
      <span class="w-70 break-all">{{ seriesDisplacements }}</span>
    </div>
    <div class="label-item flex items-start">
      <span class="w-17.5">变速箱:</span>
      <span class="w-70 break-all">{{ seriesGearboxs }}</span>
    </div>
    <div class="label-item">
      <span class="w-17.5">车身类型:</span>
      <span>{{ seriesBodys }}</span>
    </div>
  </div>
  <div class="px-6 pb-6 pt-2 flex-grow min-w-0 border-side">
    <div class="label-item flex items-center">
      <span>用户满意度:</span>
      <div class="flex">
        <BasicRate :model-value="statCacsi" :count="5" active-color="#FF551D" void-color="#B9C0D3" />
        <div class="text-orange-6 font-bold ml-3">
          {{ statCacsi }}分
        </div>
      </div>
    </div>
    <div class="label-item flex">
      <span>投诉量:</span>
      <span class="text-orange-6 font-bold">{{ statComplainTotal }}</span>
    </div>
    <div class="label-item flex">
      <span>完成率:</span>
      <span class="text-orange-6 font-bold">{{ Math.floor(statFinishRate * 10000) / 100 }}%</span>
    </div>
    <div class="label-item flex">
      <span>QT分:</span>
      <span class="text-orange-6 font-bold">{{ statQt }}</span>
    </div>
    <div class="border-b-1 border-slate-1 pb-sm mb-sm" />
    <div>
      <div class="font-bold">
        问题总结
      </div>
      <div class="label-item flex">
        <span>质量问题:</span>
        <div flex-grow>
          <BasicLabel :data-list="labels.quality" :line-count="1" />
        </div>
      </div>
      <div class="label-item flex">
        <span>销售问题:</span>
        <div>
          <BasicLabel :data-list="labels.sale" :line-count="1" />
        </div>
      </div>
      <div class="label-item flex">
        <span>售后问题:</span>
        <div>
          <BasicLabel :data-list="labels.afterSale" :line-count="1" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang='scss' scoped>
.label-item {
  padding-top: 16px;
  min-height: 36px;

  & span:first-child {
    --uno: inline-block text-3.5 text-slate-5 text-right mr-sm flex-shrink-0 whitespace-nowrap;
  }
}
</style>
